import React from "react";

const CancelledTxn = () => {
  return (
    <div className="bg-white p-4 shadow-md rounded-lg">
      <h2 className="text-2xl font-semibold mb-4">Transaction Cancelled</h2>
      <p className="text-gray-700">Transaction has been cancelled.</p>
    </div>
  );
};

export default CancelledTxn;
